const URL_PARSE_BASE = 'https://example.invalid';

const YOUTUBE_PROVIDER_HOSTS_EXACT = ['youtu.be', 'youtube.com'] as const;
const YOUTUBE_PROVIDER_HOST_SUFFIX = '.youtube.com';
const VIMEO_PROVIDER_HOSTS_EXACT = ['vimeo.com'] as const;
const VIMEO_PROVIDER_HOST_SUFFIX = '.vimeo.com';

const YOUTUBE_PROVIDER_EXACT_MATCH: readonly string[] = YOUTUBE_PROVIDER_HOSTS_EXACT;
const VIMEO_PROVIDER_EXACT_MATCH: readonly string[] = VIMEO_PROVIDER_HOSTS_EXACT;

function readHostname(url: string): string | null {
  try {
    return new URL(url, URL_PARSE_BASE).hostname.toLowerCase().replace(/^www\./, '');
  } catch {
    return null;
  }
}

/** Used by embed-block for 16:9 layout on YouTube/Vimeo iframe src URLs. */
export function isHostedVideoProviderUrl(url: string): boolean {
  const hostname = readHostname(url);
  if (!hostname) {
    return false;
  }

  return (
    YOUTUBE_PROVIDER_EXACT_MATCH.includes(hostname) ||
    hostname.endsWith(YOUTUBE_PROVIDER_HOST_SUFFIX) ||
    VIMEO_PROVIDER_EXACT_MATCH.includes(hostname) ||
    hostname.endsWith(VIMEO_PROVIDER_HOST_SUFFIX)
  );
}
